// BUTTON_BORDER constants required for calculating appropriate radius for ButtonOutline component
export const BUTTON_BORDER_RADIUS = 800;
export const BUTTON_BORDER_WIDTH = 1;
